module.exports = __webpack_public_path__ + "static/media/MegurimD.60b83324.png";